exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.muted[data-v-8a77046e]{color:#999}.small[data-v-8a77046e]{font-size:12px}.text-red[data-v-8a77046e]{color:#f5222d;font-weight:600}\n", ""]);

// exports
